/*
CampaignSpotStatus is a class-based component that fetches campaign spot information and passes it down to the SpotStatus component.

1. It is called in Campaign.js in Spot Status tab
2. It has a default date range filter from today to seven days from today.
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createSelector } from "reselect";
import * as constants from "../../../../../constants";
import { bindDispatch } from "../../../../../utils";
import WithFetchList from "../../../../hoc/withFetchList";
import SpotStatus from "../../common/SpotStatus";
import getSpotStatusDefaultDateRange from "../../utils/getSpotStatusDefaultDateRange";

class CampaignSpotStatus extends Component {
  componentDidMount = async () => {
    const {
      match: {
        params: { campaignId },
      },
      campaigns,
    } = this.props;

    const campaign = campaigns?.campaign;
    const defaultRange = getSpotStatusDefaultDateRange("campaign", campaign);

    this.props.fetchData(null, true, [
      { campaignId },
      {
        filters: [
          {
            from: defaultRange.from,
            id: "showDate",
            type: "showDate",
            displayName: defaultRange.displayName,
            to: defaultRange.to,
          },
        ],
      },
    ]);
  };

  render = () => {
    const {
      campaigns: { isTabLoading, campaignSpots },
    } = this.props;

    return (
      <SpotStatus
        {...this.props}
        data={{
          spotStatus: campaignSpots,
          isLoading: isTabLoading,
        }}
      />
    );
  };
}

export const CampaignSpotStatustWithFilters = WithFetchList("getCampaignSpots", {
  sort: [
    {
      id: "showDate",
      desc: false,
    },
  ],
  ps: constants.DEFAULT_PAGE_SIZE,
  page: 1,
  multiColumnSort: false,
})(CampaignSpotStatus);

const mapStateToProps = createSelector(
  (state) => state.campaigns,
  (state) => state.userData,
  (campaigns, userData) => ({
    campaigns,
    userData: userData.user,
  })
);

export default connect(mapStateToProps, bindDispatch)(withRouter(CampaignSpotStatustWithFilters));
